import { type HttpResponse, handleHttpRequest, http } from 'interfaces'
import { type OrgUrl, type LutValues } from 'services'

export interface UrlDescType {
  id: number
  type_desc: string
}

export interface UrlDescTypeLutValues extends LutValues {
  descTypes: UrlDescType[]
}

export async function getOrgUrlDescTypes (): Promise<UrlDescTypeLutValues> {
  const urlPath = '/api/v1/organizations/url/type/'
  return await http.get(urlPath)
    .then(value => value.data)
}
export async function createOrgUrl (url: OrgUrl): Promise<number> {
  const urlPath = `/api/v1/organizations/${url.orgId}/url/`
  return await http.post(urlPath, url, { withCredentials: true })
    .then((value) => { return value.data.result.id })
    .catch(() => { return 0 })
}

export async function updateOrgUrl (url: OrgUrl): Promise<boolean> {
  const urlPath = `/api/v1/organizations/${url.orgId}/url/${url.id}/`

  return await http.put(urlPath, url, { withCredentials: true })
    .then(() => { return true })
    .catch(() => { return false })
}

export async function deleteOrgUrl (url: OrgUrl): Promise<boolean> {
  const urlPath = `/api/v1/organizations/${url.orgId}/url/${url.id}/`
  return await http.delete(urlPath, { withCredentials: true })
    .then(() => { return true })
    .catch(() => { return false })
}

export async function getOrgUrls (orgId: number): Promise<OrgUrl[]> {
  const urlPath = `/api/v1/organizations/${orgId}/url/`
  return await http.get(urlPath)
    .then(value => value.data.data)
    .catch(reason => { return [] })
}

export async function patchOrgUrlDisplayOrder (orgId: number, typeOfDataSource: string, orgUrlsById: Record<number, number>, urlSelected: number): Promise<HttpResponse<OrgUrl[]>> {
  return await handleHttpRequest(http.patch(`/api/v1/organizations/${orgId}/url/`, {
    idAndDisplayOrderMap: orgUrlsById,
    type: typeOfDataSource,
    urlIdSelected: urlSelected
  }))
}
